import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  FlexDirection,
  Heading2,
  JustifyContent,
  Strong,
  TextAlign,
} from '@gousto-internal/citrus-react';
import { RecipeOptionButton } from './layout';

type Props = {
  value: number;
  options: number[];
  onChange: (recipes: number) => void;
};

export function RecipeSelector({ value, options, onChange }: Props) {
  return (
    <Box
      display={Display.Flex}
      flexDirection={[FlexDirection.Column, null, FlexDirection.Row]}
      alignItems={[AlignItems.Stretch, null, AlignItems.Center]}
      justifyContent={JustifyContent.SpaceBetween}
      gap={3}
    >
      <Heading2 id="recipeSelectorLabel">Select number of recipes</Heading2>
      <Box role="group" aria-labelledby="recipeSelectorLabel" display={Display.Flex}>
        {options.map((recipes) => {
          const selected = recipes === value;

          return (
            <RecipeOptionButton
              key={recipes}
              type="button"
              aria-pressed={selected}
              data-selected={selected}
              onClick={() => onChange(recipes)}
            >
              <Body2 color={Color.Inherit} textAlign={TextAlign.Center}>
                <Strong>{recipes}</Strong>
              </Body2>
            </RecipeOptionButton>
          );
        })}
      </Box>
    </Box>
  );
}
